import styles from "./OurStory.module.css";

const OurStory = () => {
  return (
    <section className={styles["our-story-section"]}>
      <div className={styles["our-story-content"]}>
        <h3>Наша прича</h3>
        <div className={styles["left-side__paragraphs"]}>
          <p>
            Авионик је регионални лидер у авио-саобраћају још од оснивања компаније 1927. године. Сада, уз ново име и са
            новим идентитетом, широм наше растуће мреже линија можемо да понудимо нов концепт удобности током лета.
          </p>
          <p>
            Авионик лети или планира да лети до преко 100 дестинација у Европи, Северној Америци и на Блиском истоку.
          </p>
          <p>
            Посредством наших партнерских авио-компанија у прилици смо да вам понудимо летове до великог броја
            дестинација у Европи, Азији и Африци.
          </p>
          <p>
            Решени смо да стратешким променама које су у току наставимо да играмо кључну улогу у развоју ваздухопловства
            у Србији, српске индустрије путовања и туристичке привреде Србије.
          </p>
          <p>
            Приоритет Авионика је пружање услуге изузетног квалитета за наше путнике. Циљ нам је да корисницима услуга
            наше компаније пружимо максималну удобност током путовања, без обзира на класу којом лете.
          </p>
        </div>
      </div>
    </section>
  );
};

export default OurStory;
